import { css } from "@emotion/core";

export const carouselCss = css`
    width: 100%;
    overflow: hidden;
    position: relative;

    .cr-content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        transition: transform 0.25s linear;
        will-change: transform;
    }

    .cr-content-hor {
        flex-flow: column;
    }

    .btn {
        position: absolute;
        border: 0;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        outline: none;

        &[disabled] {
            pointer-events: none;
            opacity: 0.2;
        }
    }

    &.cr-hor {
        .btn-prev {
            top: 0;
            left: 0;
            height: 100%;
        }

        .btn-next {
            top: 0;
            right: 0;
            height: 100%;
        }
    }

    &.cr-ver {
        .btn-prev {
            top: 0;
            left: 0;
            width: 100%;
        }

        .btn-next {
            bottom: 0;
            left: 0;
            width: 100%;
        }

        .btn-bottom-next {
            right: 0;
        }
    }
`;
